var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3C3C3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.973.1C4.275.542 1.999 2.4.976 5c-1.024 2.6-.646 5.56.995 7.8L.193 14.758c-.195.215-.248.528-.133.798.114.27.374.444.66.443h7.167c4.254.066 7.814-3.293 8.106-7.648.101-2.4-.854-4.722-2.603-6.321C11.642.43 9.286-.278 6.973.1z",
    transform: "translate(-683 -671) translate(683 671) matrix(-1 0 0 1 16 0)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.809 9.327c0-1.166 1.848-1.364 1.848-3.124 0-1.298-1.145-2.035-2.795-2.035-1.484 0-2.519.572-3.112 1.474l1.33.781c.353-.506.891-.814 1.596-.814.714 0 1.188.341 1.188.88 0 .957-1.717 1.298-1.717 2.838H8.81zm-.825 2.761c.616 0 1.056-.451 1.056-1.001 0-.561-.44-.979-1.056-.979-.617 0-1.056.418-1.056.979 0 .55.44 1.001 1.056 1.001z",
    transform: "translate(-683 -671) translate(683 671)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/Help.a93dba520ac1192c71b77ba6cf2570d2.blank.svg";